import { ParametersSummary } from './ParametersSummary';
import { ProductDetailsSummary } from './ProductDetailsSummary';
import { ExperianIcon } from '@/app/features/products/summary/ExperianIcon';
import { ProgramSummaryFooter } from '@/app/features/products/summary/ProgramSummaryFooter';
import { ProgramDataType, Job, AscendUSAAProgram } from '@ssar-app/domain';
import { useState, Fragment } from 'react';
import { Modal, Spin } from '@ssar-app/uikit';
import { Flex, Text } from '@chakra-ui/react';

export interface ProgramSummaryModalProps {
  model: ProgramDataType;
  job?: Job;
  version: string;
  onCancel?: () => void;
  showAccept?: boolean;
  onAccept?: () => void;
  onOk?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDownload?: (arg0: any) => void;
  programId: string;
}

export const ProgramSummaryModal = (props: ProgramSummaryModalProps) => {
  const {
    model,
    // job,
    // programId,
    // version,
    showAccept,
    onAccept,
    onCancel,
    onDownload,
    onOk,
  } = props;
  const [isLoadingData, _setIsLoadingData] = useState(false);
  const summaryModel = model as AscendUSAAProgram;

  return (
    <Fragment>
      <Modal
        footer={
          isLoadingData ? (
            <></>
          ) : (
            <ProgramSummaryFooter
              model={summaryModel}
              showAccept={showAccept}
              onAccept={onAccept}
              onCancel={onCancel}
              onDownload={onDownload}
              onOk={onOk}
            />
          )
        }
        isOpen
        header='Program Summary'
        contentProps={{ maxW: '80%' }}
        onClose={() => {
          const closeFn = onCancel || onOk;
          closeFn && closeFn();
        }}
      >
        {summaryModel && (
          <Fragment>
            <style
              dangerouslySetInnerHTML={{
                __html: `
                  * {
                    scrollbar-width: thin;
                    scrollbar-color: #A6A6A6 #A6A6A6;
                  }
                  *::-webkit-scrollbar {
                    width: 10px;
                    height: 10px;
                  }
                  *::-webkit-scrollbar-track {
                    background: #D9D9D9;
                  }
                  *::-webkit-scrollbar-thumb {
                    background-color: #A6A6A6;
                    border-radius: 20px;
                  }

                  `,
              }}
            ></style>
            <Spin spinning={isLoadingData} tip=''>
              {isLoadingData && (
                <Text textAlign='center' mt={20}>
                  Loading program summary data...
                </Text>
              )}
              {!isLoadingData && (
                <>
                  <Flex direction='column'>
                    <ExperianIcon />
                    <Text
                      as='span'
                      sx={{
                        textAlign: 'center',
                        fontSize: 16,
                        textColor: 'rgb(29, 79, 145)',
                      }}
                    >
                      Program Summary
                    </Text>
                    <ProductDetailsSummary
                      job={props?.job}
                      productDetails={
                        summaryModel?.productInput?.productDetails
                      }
                    />
                    <br />
                    <br />
                    <ParametersSummary
                      model={summaryModel?.packagesInput?.parameters}
                    />
                  </Flex>
                </>
              )}
            </Spin>
          </Fragment>
        )}
      </Modal>
    </Fragment>
  );
};
